
import { defineComponent, PropType } from 'vue'
import CustomerService from '@/views/_components/customer-service/customer-service.vue'

export default defineComponent({
  components: { CustomerService },

  props: {
    activeIndex: {
      type: Number,
      default: 0
    },
    steps: {
      type: Array as PropType<string[]>,
      default: () => (['第一步', '第二步', '第三步'])
    }
  },

  setup (props, context) {
    return {

    }
  },
})
